import React from "react";
import { Form, Input, Space, Typography } from "antd";
import FloatLabel from "./FloatLabel";
import { GRAY5, GRAY_PLACEHOLDER } from "../../constant/colors";
import { decimalRegex, formatToDecimal, limitDecimalInputPrecision } from "../../utils/formaters";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

const CustomInputNumber = ({
  name,
  children,
  value,
  onChange,
  label,
  rules = [],
  required = false,
  precision = 2,
  style = {},
  bordered = false
}) => {
  const { t } = useTranslation();

  return (
    <Form.Item
      name={name}
      required={false}
      rules={[
        {
          pattern: decimalRegex,
          message: t("form.validation.numbers_only")
        },
        ...rules
      ]}
    >
      <FloatLabel
        label={
          <Space size={6}>
            {required && <Text style={{ color: GRAY_PLACEHOLDER }}>*</Text>}
            <Text style={{ color: GRAY_PLACEHOLDER }}>{label}</Text>
          </Space>
        }
        name={label}
        inputValue={value}
      >
        <Input
          formatter={(e) => formatToDecimal(e.target.value)}
          onKeyDown={(e) => limitDecimalInputPrecision(e, precision)}
          onPaste={(e) => {
            if (isNaN(e?.target?.value)) {
              e.preventDefault();
              return false;
            }
          }}
          value={value}
          onChange={onChange}
          bordered={bordered}
          style={
            !bordered
              ? {
                  height: 39,
                  width: "100%",
                  border: "0px",
                  borderBottom: `1px solid ${GRAY5}`,
                  padding: label ? "7px 0 0px 0" : "",
                  ...style
                }
              : style
          }
        >
          {children}
        </Input>
      </FloatLabel>
    </Form.Item>
  );
};

export { CustomInputNumber };
